// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * Admin Portal
 * Screen Viewed
 */
export const trackAdminPortalScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Admin Portal',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'adminPortal',
    screen: 'adminPortal',
  }

  return ['Screen Viewed', payload]
}

/**
 * Admin Portal
 * Tile Tapped
 */
export type TrackAdminPortalTileTappedType = {
  title: string
}

export const trackAdminPortalTileTappedPayload = ({
  title,
}: TrackAdminPortalTileTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Admin Portal',
    event_description: 'Tile Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'adminPortalTile',
    screen: 'adminPortal',
    destination: 'adminPortalMFE',
    title: title,
  }

  return ['Button Tapped', payload]
}

/**
 * Admin Portal
 * MFE Screen Viewed
 */
export type TrackAdminPortalMfeScreenViewedType = {
  url: string
}

export const trackAdminPortalMfeScreenViewedPayload = ({
  url,
}: TrackAdminPortalMfeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Admin Portal',
    event_description: 'MFE Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'adminPortalMFE',
    screen: 'adminPortalMFE',
    url: url,
  }

  return ['Screen Viewed', payload]
}

/**
 * Screen Enum Values
 * To be used in screen parameters
 */
export enum ScreenEnums {
  AdminPortal = 'adminPortal',
  AdminPortalMFE = 'adminPortalMFE',
}
